/** Brush appearance definitions; no p5, shared runtime, or CPU stamp renderer. */
const rows=[
  ['pen',.3,.15,.9,.7,150,.1,{curve:[.15,.2],min_max:[1.2,1]}],
  ['rotring',.15,.05,.7,.9,210,.1,{curve:[.35,.2],min_max:[1.3,1]}],
  ['2B',.3,.75,.45,.8,180,.1,{curve:[.1,.3],min_max:[1.1,.9]}],
  ['HB',.3,.6,.3,.7,170,.1,{curve:[.15,.2],min_max:[1.1,.9]}],
  ['2H',.2,.6,.3,.75,120,.1,{curve:[.15,.2],min_max:[1.1,.9]}],
  ['cpencil',.35,.55,.8,.7,75,.1,{curve:[.15,.2],min_max:[.95,1.1]}],
  ['pastel',.7,5,.91,1,30,.085/3,{curve:[.4,.05],min_max:[1.09,.93]}],
  ['crayon',.33,1.9,.75,2,159,.07,[1.1,.9]],
  ['charcoal',.35,1.5,.68,2,120,.03,{curve:[.15,.4],min_max:[1.1,.95]}],
  ['spray',.2,6,15,40,90,.5,{curve:[.2,.35],min_max:[.7,1]},'spray'],
  ['marker',2,.2,1,1,1,.03,{curve:[.35,.25],min_max:[1.2,.85]},'marker'],
];
export function createProfiles() {
  return new Map(rows.map(([name,weight,scatter,sharpness,grain,opacity,spacing,pressure,type='default'])=>
    [name,normalizeProfile({weight,scatter,sharpness,grain,opacity,spacing,pressure,type,noise:name==='pastel'||name==='crayon'?1:.3})]));
}
export function normalizeProfile(input) {
  if(!input||typeof input!=='object'||Array.isArray(input))throw new TypeError('Brush parameters must be an object.');
  const p={type:'default',weight:1,scatter:.2,sharpness:.7,grain:1,opacity:150,spacing:.5,pressure:[1,1],rotate:'natural',markerTip:true,noise:.3,...input};
  if(input.vibration!==undefined && input.scatter===undefined)p.scatter=input.vibration;
  if(input.definition!==undefined && input.sharpness===undefined)p.sharpness=input.definition;
  if(input.quality!==undefined && input.grain===undefined)p.grain=input.quality;
  if(!['default','spray','marker','custom','image'].includes(p.type))throw new TypeError('Unknown brush type: '+p.type);
  for(const name of ['weight','spacing']) if(!Number.isFinite(p[name])||p[name]<=0)throw new RangeError(name+' must be positive.');
  for(const name of ['scatter','grain','sharpness','noise'])if(!Number.isFinite(p[name])||p[name]<0)throw new RangeError(name+' must be finite and nonnegative.');
  if(!Number.isFinite(p.opacity)||p.opacity<0||p.opacity>255)throw new RangeError('opacity must be between 0 and 255.');
  if(!['none','natural','random'].includes(p.rotate))throw new TypeError('rotate must be none, natural or random.');
  if(typeof p.markerTip!=='boolean')throw new TypeError('markerTip must be a boolean.');
  const samples=(values,label,minLength,maxLength,nonnegative=true)=>{
    if((!Array.isArray(values)&&!ArrayBuffer.isView(values))||!Number.isInteger(values.length)||values.length<minLength||values.length>maxLength)throw new TypeError(label+' has an invalid sample count.');
    const result=Array.from(values);
    if(result.some(value=>!Number.isFinite(value)||(nonnegative&&value<0)))throw new RangeError(label+' samples must be finite'+(nonnegative?' and nonnegative.':'.'));
    return result;
  };
  if(typeof p.pressure==='number'){
    if(!Number.isFinite(p.pressure)||p.pressure<0)throw new RangeError('pressure must be finite and nonnegative.');
  }else if(Array.isArray(p.pressure)||ArrayBuffer.isView(p.pressure))p.pressure=samples(p.pressure,'pressure',1,3);
  else if(typeof p.pressure!=='function'){
    if(!p.pressure||typeof p.pressure!=='object')throw new TypeError('pressure must be a number, array, curve object or callback.');
    const pressure={...p.pressure};
    if(typeof pressure.curve!=='function')pressure.curve=samples(pressure.curve??[.15,.2],'pressure curve',2,2);
    if(pressure.min_max!==undefined)pressure.min_max=samples(pressure.min_max,'pressure min_max',2,2);
    if(pressure.variation!==undefined){
      if(!pressure.variation||typeof pressure.variation!=='object'||Array.isArray(pressure.variation))throw new TypeError('pressure variation must be an object.');
      pressure.variation={...pressure.variation};
      for(const value of Object.values(pressure.variation))if(!Number.isFinite(value)||value<0)throw new RangeError('pressure variation values must be finite and nonnegative.');
    }
    p.pressure=pressure;
  }
  if(p.pressureLUT!==undefined)p.pressureLUT=new Float32Array(samples(p.pressureLUT,'pressureLUT',1,2048));
  if(p.type==='custom'&&typeof p.tip!=='function')throw new TypeError('A custom brush requires a tip(surface) function.');
  if(p.image!==undefined){if(!p.image||typeof p.image!=='object')throw new TypeError('image must be an object.');p.image={...p.image};}
  if(p.type==='image'&&(typeof p.image?.src!=='string'||!p.image.src.trim()))throw new TypeError('An image brush requires image.src.');
  return p;
}
